import React, { memo } from "react";
import { Box, Typography, Avatar } from "@mui/material";
import clock from "../../img/fancy_clock.svg";

export const AvgResponseTimeComponent = memo(({ avgResponseTime }) => {
  if (avgResponseTime === 0) {
    return (
      <Typography
        variant="caption"
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          color: 'secondary.main',
          whiteSpace: 'nowrap',
          px: 1,
          py: 0.5,
          backgroundColor: 'secondary.50',
          borderRadius: 1,
        }}
      >
        Neu
      </Typography>
    );
  }
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Avatar
        src={clock}
        sx={{
          width: 23,
          height: 23,
          backgroundColor: 'transparent',
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          color: 'secondary.main',
          whiteSpace: 'nowrap',
        }}
      >
        Ø {avgResponseTime} h
      </Typography>
    </Box>
  );
});

AvgResponseTimeComponent.displayName = 'AvgResponseTimeComponent';
